import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import './styles/index.scss'
import HtmlParser from 'react-html-parser'
import { formattedParsableString } from 'utils/helpers'

const DEFAULT_SHOW_MORE_BREAKPOINT = '240px'
const SHOW_MORE_BREAKPOINT_REGEX = /^\d*\.?\d+px$/i

const getValidatedShowMoreBreakpoint = (value) => {
  if (value === null || value === undefined) return null
  if (typeof value !== 'string') return DEFAULT_SHOW_MORE_BREAKPOINT
  const normalizedValue = value.trim().toLowerCase()
  if (!SHOW_MORE_BREAKPOINT_REGEX.test(normalizedValue)) return DEFAULT_SHOW_MORE_BREAKPOINT
  if (parseFloat(normalizedValue) <= 0) return DEFAULT_SHOW_MORE_BREAKPOINT
  return normalizedValue
}

const getHeightInPx = (heightValue) => {
  const numericValue = parseFloat(heightValue)
  if (Number.isNaN(numericValue)) return parseFloat(DEFAULT_SHOW_MORE_BREAKPOINT)
  return numericValue
}

const AboutUsV1 = ({ showMoreBreakpoint }) => {
  const { languageData } = useSelector((state) => state.language)
  const [showAllContent, setShowAllContent] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)
  const [contentHeightPx, setContentHeightPx] = useState(0)
  const contentRef = useRef(null)

  const validatedShowMoreBreakpoint = getValidatedShowMoreBreakpoint(showMoreBreakpoint)
  const isShowMoreEnabled = Boolean(validatedShowMoreBreakpoint)
  const showMoreBreakpointInPx = isShowMoreEnabled ? getHeightInPx(validatedShowMoreBreakpoint) : null
  const homeAboutContent = formattedParsableString(languageData?.homeAboutContent || '')
  const showMoreText = languageData?.showMore || languageData?.promReadMore || 'Show More'
  const showLessText = languageData?.showLess || 'Show Less'
  const contentClassName = `aboutus-content${isShowMoreEnabled && isTruncated
    ? showAllContent ? ' aboutus-content--expanded' : ' aboutus-content--collapsed'
    : ''}`

  useEffect(() => {
    setShowAllContent(false)
  }, [homeAboutContent, validatedShowMoreBreakpoint])

  useEffect(() => {
    const updateTruncation = () => {
      if (!isShowMoreEnabled) {
        setIsTruncated(false)
        return
      }
      if (!contentRef.current) return
      const scrollHeight = contentRef.current.scrollHeight
      setContentHeightPx(scrollHeight)
      setIsTruncated(scrollHeight > showMoreBreakpointInPx)
    }

    updateTruncation()
    window.addEventListener('resize', updateTruncation)
    return () => window.removeEventListener('resize', updateTruncation)
  }, [homeAboutContent, isShowMoreEnabled, showMoreBreakpointInPx])

  return (
    <section className='wrapper-content aboutus'>
      <section className='tabs-section home-tabs'>
        <div className='wrapper'>
          <div className='container'>
            <ul className='nav nav-pills mb-3' id='pills-tab' role='tablist'>
              <li className='nav-item'>
                <a
                  className='nav-link active home-aboutus' id='pills-about-tab' data-toggle='pill' href='#pills-about'
                  role='tab' aria-controls='pills-about' aria-selected='true'
                >
                  {HtmlParser(formattedParsableString(languageData?.homeAbout || ''))}
                </a>
              </li>
            </ul>
            <div className='tab-content about-section' id='pills-tabContent'>
              <div
                className='tab-pane fade show active' id='pills-about' role='tabpanel'
                aria-labelledby='pills-about-tab'
              >
                <div
                  ref={contentRef}
                  className={contentClassName}
                  style={isShowMoreEnabled
                    ? {
                        '--aboutus-collapsed-height': validatedShowMoreBreakpoint,
                        '--aboutus-expanded-height': `${contentHeightPx}px`
                      }
                    : undefined}
                >
                  {HtmlParser(homeAboutContent)}
                </div>
                {isShowMoreEnabled && isTruncated && (
                  <button
                    type='button'
                    className='btn btn-link aboutus-show-more'
                    onClick={() => setShowAllContent((previousValue) => !previousValue)}
                    aria-expanded={showAllContent}
                  >
                    {showAllContent ? showLessText : showMoreText}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}

export default AboutUsV1
